<template>
    <div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>
        <div class="card">
            <div class="flex card-container blue-container overflow-hidden">
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" @click="cierraVentana()" v-tooltip.right="'Cerrar'" />
                </div>
                <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">{{ comparativa.textoComparativa }} ({{ comparativa.año }})</h1>
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="mdi mdi-content-save-check" class="p-button-rounded p-button-outlined" style="color:#107C41" @click="PostComparativa()" v-tooltip.right="'Guardar'" />
                </div>
            </div>
            <hr size=7 color="#FF6699">
        </div>
        <div class="card">
            <DataTable :value="comparativa.comparativa" :scrollable="true" scrollHeight="500px" scrollDirection="both" editMode="cell" @cell-edit-complete="onCellEditComplete" class="editable-cells-table" responsiveLayout="scroll">
                <Column field="mes" header="Mes">
                </Column>
                <Column field="comparativa" header="Importe"
                    :styles="{ 'flex-grow': '1', 'flex-basis': '150px' }">
                    <template #editor="slotProps">
                        <InputText v-model="slotProps.data.comparativa" autofocus />
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";
    import XLSX from 'xlsx'
    export default {
        components: {
            
        },
        data() {
            return {
                loading: false,
                loadingMensaje: '',
                rutaAxios : 'https://api-mongo.contago.com.mx/api/',
                // rutaAxios : 'https://localhost:44322/api/',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
            comparativa(){
                return this.$store.state.comparativaStore;
            },
        },
        created() {

        },
        methods: {
            async PostComparativa(){
                const valor = { ...this.comparativa }
                console.log(this.comparativa)
                this.loading = true;
                this.loadingMensaje = 'Consultando, espere...'
                try{
                    let response = await axios.post(this.rutaAxios + 'Comparativa/PostComparativaAsync/'+ this.token.empresaBase + '/' + valor.año + '/' + valor.tipo, valor.comparativa);
                    this.loading = false
                    // this.cierraVentana();
                }catch(error){
                    console.log(error)
                    this.loading = false;
                }
            },

            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            cierraVentana(){
                let comparativaD = {
                    textoComparativa: '',
                    tipo: '',
                    año: '',
                    comparativa: [],
                }
                this.$store.state.comparativaStore = { ...comparativaD }
                this.$emit('closeDialogComparativa')
            },

            onCellEditComplete(event) {
                let { data, newValue, field } = event;
                let valor = this.formatCurrency(newValue);
                data[field] = valor;
            },
        },
    }
</script>